import React from 'react';
import { createRoot } from 'react-dom/client';
import ExactoApp from './ExactoApp';
import ErrorBoundary from './components/shared/ErrorBoundary';
import './i18n'; // i18n initialization (must run before any component renders)
import './index.css';
import './styles/animations.css';

// Polyfill for global
window.global = window;

// Lock page zoom so the app feels "fixed" like bookaroom/nidoux (iOS Safari ignores
// user-scalable=no, so this is what actually stops pinch / double-tap from zooming the
// whole page). Interactive surfaces that need their own zoom (e.g. the rentability area
// map) attach their own non-passive listeners and read the touches themselves, so this
// only suppresses the BROWSER's default page zoom — it doesn't block in-component zoom.
(() => {
  const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  // Prevent double-tap to zoom
  let lastTouchEnd = 0;
  document.addEventListener('touchend', (e) => {
    const now = Date.now();
    if (now - lastTouchEnd <= 300) {
      e.preventDefault();
    }
    lastTouchEnd = now;
  }, { passive: false });

  // Prevent pinch zoom (all devices)
  document.addEventListener('touchmove', (e) => {
    if (e.touches.length > 1) {
      e.preventDefault();
    }
  }, { passive: false });

  if (isiOS) {
    // Block pinch gestures on iOS
    ['gesturestart', 'gesturechange', 'gestureend'].forEach((type) => {
      document.addEventListener(type, (e) => e.preventDefault(), { passive: false });
    });
  }
})();

// Primary SPA entry point — mounts the full ExactoApp on #root
const rootElement = document.getElementById('root');
if (rootElement) {
  createRoot(rootElement).render(
    <ErrorBoundary>
      <ExactoApp />
    </ErrorBoundary>
  );
}
